import { render } from "./sv-button.vue?vue&type=template&id=28e6b50d&ts=true"
import script from "./sv-button.vue?vue&type=script&lang=ts"
export * from "./sv-button.vue?vue&type=script&lang=ts"

import "./sv-button.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__